import React, { useMemo } from 'react';
import { useTheme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';
import { translate } from 'components/Translation';
import ServicePicker from 'components/ServicePicker';
import PriceCell from '../common/cells/PriceCell';

interface MobileInternetPlansTableProps {
	packages: SinglePackage[];
	selectedTab: number | null;
	setSelectedTab: React.Dispatch<React.SetStateAction<number | null>>;
	type: types.services.tableType;
	activePackages: SinglePackage[];
}

const MobileInternetPlansTable = ({
	packages,
	setSelectedTab,
	selectedTab,
	type,
	activePackages,
}: MobileInternetPlansTableProps) => {
	const theme = useTheme();
	const xsDown = useMediaQuery(theme.breakpoints.down('xs'));

	const activePackagesPartNumbers = useMemo(() => activePackages.map(({ partNumber }) => partNumber), [
		activePackages,
	]);

	const tabs = useMemo(() => {
		return packages.map((singlePackage) => {
			const isPackageActivated = activePackagesPartNumbers.indexOf(singlePackage.partNumber) >= 0;
			return {
				column: (
					<PriceCell
						price={String(singlePackage.price || 0)}
						currency={singlePackage.priceCurrency}
						perMonth={type === 'PLAN'}
						backgroundColor="white"
					/>
				),
				numberOfCells: 2,
				header: {
					title: singlePackage.name,
					superscription: type === 'TOP_UP' ? translate('number.services.top.up') : undefined,
					height: 130,
				},
				currentPlan: isPackageActivated,
				disabled: isPackageActivated,
			};
		});
	}, [packages, type, activePackagesPartNumbers]);

	return (
		<div>
			<ServicePicker
				selectedTab={selectedTab}
				setSelectedTab={setSelectedTab}
				tabs={tabs}
				numberOfTabsOnSlide={xsDown ? 1 : 5}
				selectedTabColor="primary"
			/>
		</div>
	);
};

export default MobileInternetPlansTable;
